import type { OrderInfo } from '@@partner:types:app'

import React from 'react'
import { Badge, Placeholder } from 'rsuite'

import OrderCard from './OrderCard'

import './KanbanColumn.scss'

export interface KanbanColumnProps {
  brandSlug: string
  label: string
  orders: OrderInfo[]
  loading?: boolean
}

function KanbanColumn ({ brandSlug, label, orders, loading }: KanbanColumnProps) {
  return (
    <div className="KanbanColumn">
      {/* Шапка колонки (sticky) */}
      <div className="KanbanColumn__Header">
        <div className="KanbanColumn__Title">
          {label}
        </div>
        <Badge className="KanbanColumn__Count" content={orders.length} />
      </div>

      {/* Контент с вертикальным скроллом */}
      <div className="KanbanColumn__Content">
        {loading ? (
          // Skeleton loading
          <>
            {[ 1, 2, 3, 4, 5 ].map(i => (
              <div key={i} className="OrderCard OrderCard--skeleton">
                <Placeholder.Paragraph rows={2} active />
              </div>
            ))}
          </>
        ) : orders.length === 0 ? (
          // Empty state
          <div className="KanbanColumn__Empty">
            Нет заказов
          </div>
        ) : (
          // Карточки заказов
          orders.map(order => (
            <OrderCard
              key={order.id}
              order={order}
              brandSlug={brandSlug}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default React.memo(KanbanColumn)
